"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekDay = exports.VendorResultStatus = exports.SupportStatus = exports.decision = exports.RewardCalculationState = exports.ProductTypeResponse = exports.ProductType = exports.PowerDeliveryState = exports.OnboardingProgress = exports.NotificationType = exports.Brand = void 0;
/**
 * The request user's account brand
 */
exports.Brand = {
    ENERGIEDIRECT: 'energiedirect',
    ESSENT: 'essent'
};
/**
 * Type of notification
 */
exports.NotificationType = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error'
};
/**
 * Deprecated. Use onboarding.progress instead
 */
exports.OnboardingProgress = {
    NEW_CUSTOMER: 'new_customer',
    CONNECT_CAR: 'connect_car',
    FINISHED: 'finished'
};
/**
 * The vehicle power delivery state
 */
exports.PowerDeliveryState = {
    UNKNOWN: 'unknown',
    UNPLUGGED: 'unplugged',
    PLUGGED_IN_INITIALIZING: 'plugged_in_initializing',
    PLUGGED_IN_CHARGING: 'plugged_in_charging',
    PLUGGED_IN_STOPPED: 'plugged_in_stopped',
    PLUGGED_IN_COMPLETE: 'plugged_in_completed',
    PLUGGED_IN_NO_POWER: 'plugged_in_no_power',
    PLUGGED_IN_FAULT: 'plugged_in_fault'
};
/**
 * The product type for the customer
 */
exports.ProductType = {
    SMART_CHARGING_DYNAMIC: 'SMART_CHARGING_DYNAMIC',
    SMART_CHARGING_FLEX: 'SMART_CHARGING_FLEX'
};
/**
 * The product type the customer is eligible to subscribe for.
 */
exports.ProductTypeResponse = {
    SMART_CHARGING_DYNAMIC: 'SMART_CHARGING_DYNAMIC',
    SMART_CHARGING_FLEX: 'SMART_CHARGING_FLEX',
    NONE: 'NONE'
};
/**
 * The state of the reward calculation. Only applicable for FLEX charging sessions.
 */
exports.RewardCalculationState = {
    REWARDED: 'rewarded',
    PENDING: 'pending',
    NO_REWARD_NOT_ACTIVE_IN_FLEX_POOL: 'no_reward_not_active_in_flex_pool',
    NO_REWARD_NOT_AT_HOME: 'no_reward_not_at_home',
    NO_REWARD_CHARGING_POLICY_INACTIVE: 'no_reward_charging_policy_inactive',
    NO_REWARD_POWER_TOO_LOW: 'no_reward_power_too_low',
    NO_REWARD_DURATION_TOO_SHORT: 'no_reward_duration_too_short',
    NO_REWARD_BOOSTMODE_WAS_USED: 'no_reward_boostmode_was_used'
};
/**
 * The decision of the schedule item
 */
exports.decision = {
    NO_DECISION: 'NO_DECISION',
    WAITING: 'WAITING',
    CHARGING: 'CHARGING'
};
/**
 * The status of the support for smart charging for the vehicle
 */
exports.SupportStatus = {
    UNKNOWN: 'unknown',
    SUPPORTED: 'supported',
    NOT_SUPPORTED: 'not_supported'
};
/**
 * Status code for the error or cancel state
 */
exports.VendorResultStatus = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    USER_CANCELED: 'USER_CANCELED'
};
/**
 * The day of the week the charge policy schedule applies to
 */
exports.WeekDay = {
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
    SUNDAY: 'Sunday'
};
